import React from "react";
import { Typography } from "antd";

const { Title,  } = Typography;

const ErrorPage = () => {
  return (
    <div>
      <Title level={4}>
        An error occurred on the server <br/> please try again later.
      </Title>
    </div>
  );
};

export default ErrorPage;